var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8532 4.62301C15.5195 4.95665 14.947 5.05814 14.6134 4.72449L13.1639 3.27499C12.7972 2.90834 12.2028 2.90833 11.8361 3.27499L10.3866 4.7245C10.053 5.05814 9.48047 4.95665 9.14682 4.62301C8.03567 3.51186 6.23415 3.51186 5.12301 4.62301C4.01186 5.73415 4.01186 7.53567 5.12301 8.64682C5.45665 8.98047 5.55815 9.55295 5.2245 9.8866L3.77499 11.3361C3.40834 11.7028 3.40834 12.2972 3.77499 12.6639L5.22449 14.1134C5.55814 14.447 6.13063 14.3456 6.46428 14.0119C7.57542 12.9008 9.37694 12.9008 10.4881 14.0119C11.5992 15.1231 11.5992 16.9246 10.4881 18.0357C10.1544 18.3694 10.053 18.9419 10.3866 19.2755L11.8361 20.725C12.2028 21.0917 12.7972 21.0917 13.1639 20.725L14.6134 19.2755C14.947 18.9419 15.5195 19.0433 15.8532 19.377C16.9643 20.4881 18.7658 20.4881 19.877 19.377C20.9881 18.2658 20.9881 16.4643 19.877 15.3532C19.5433 15.0195 19.4419 14.447 19.7755 14.1134L21.225 12.6639C21.5917 12.2972 21.5917 11.7028 21.225 11.3361L19.7755 9.8866C19.4419 9.55296 19.5433 8.98047 19.877 8.64682C20.9881 7.53568 20.9881 5.73416 19.877 4.62301C18.7658 3.51186 16.9643 3.51186 15.8532 4.62301Z",
    fill: "#7075E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.37aecafad13b6741c80f245632aca55d.svg";
export { ForwardRef as ReactComponent };